import { ProductDonationRecurrenceInterval, StripeRecurringInterval } from "@simplyk/common";

import {
  DONATION_RECURRENCES,
  DonationFrequency,
  getStripeIntervalFromDonationFrequency,
} from "@/common/helpers/donationRecurrence";

export const getStripeRecurrenceInterval = (
  recurrenceInterval: ProductDonationRecurrenceInterval
): StripeRecurringInterval | null => getStripeIntervalFromDonationFrequency(recurrenceInterval);

export function getDefaultRecurrenceInterval(
  hasSuggestedAmounts: Record<DonationFrequency, boolean>,
  formDefaultAmountsFrequency?: ProductDonationRecurrenceInterval | null
): StripeRecurringInterval | null {
  if (formDefaultAmountsFrequency && hasSuggestedAmounts[formDefaultAmountsFrequency]) {
    return getStripeRecurrenceInterval(formDefaultAmountsFrequency);
  }

  const firstFrequencyWithAmounts = DONATION_RECURRENCES.find(
    (recurrence) => hasSuggestedAmounts[recurrence.frequency]
  );
  return firstFrequencyWithAmounts?.stripeInterval ?? null;
}
